var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"stemp"}},[_c('el-row',{attrs:{"gutter":20}},_vm._l((_vm.data),function(item,key){return _c('el-col',{key:item,attrs:{"span":6}},[_c('div',{staticClass:"round-list"},[_c('span',[_vm._v(_vm._s(key + 1))])])])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }